import React from "react";
import { Stack, Button } from "@mui/material";
import { Save, Cancel } from "@mui/icons-material";

const ButtonGroup = ({ onSave, onCancel }) => {
  return (
    <Stack direction="row" spacing={2} justifyContent="flex-end">
      <Button variant="contained" color="primary" onClick={onSave} startIcon={<Save />}>
        Save
      </Button>
      <Button variant="outlined" onClick={onCancel} startIcon={<Cancel />}>
        Cancel
      </Button>
    </Stack>
  );
};

export default ButtonGroup;